// removed by extract-text-webpack-plugin
module.exports = {"table":"src-components-markdown----table-module---table---ql7wY borderWidth-1 borderStyle-solid borderColor-smoke marginTop-m marginBottom-m overflow-hidden borderRadius-m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/markdown/table.module.css
// module id = 727
// module chunks = 87034247430840 144482056661899